import { mutatorAction } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import { getStateAndCreateIfUndefined } from "./mutatorUtils";

const selectFocusedInboxOptionMutator: (isFocusedInboxEnabled: boolean, mailboxInfo: MailboxInfo) => void = mutatorAction("selectFocusedInboxOption", function selectFocusedInboxOption(isFocusedInboxEnabled: boolean, mailboxInfo: MailboxInfo): void {
    const optionState = getStateAndCreateIfUndefined(mailboxInfo);
    optionState.isEnabled = isFocusedInboxEnabled;
});
export default selectFocusedInboxOptionMutator;
